import { Dic } from '@src/common/utils'
import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
const tableOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: false,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '140px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: i18n.t('personAccess.title.noData'),
    menu: false,
    column: [
      {
        label: '岗位名称',
        prop: 'deptName',
        addDisplay: true,
        editDisplay: true,
        overHidden: true,
        search: true,
        searchPlaceholder: '请输入岗位名称',
        span: 12
      },
      {
        label: '所属部门',
        prop: 'parentName',
        addDisplay: true,
        editDisplay: true,
        overHidden: true,
        search: false,
        searchPlaceholder: '请输入岗位名称',
        span: 12
      },
      {
        label: '岗位说明',
        prop: 'desc',
        span: 12
      }
    ]
  }
}
export default tableOption
